exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-a93992d4] {\n  max-width: 500px;\n}\n.sub-header[data-v-a93992d4] {\n  font-size: 0.8em;\n  margin-bottom: 10px;\n}\n.modal-body[data-v-a93992d4] {\n  padding: 16px 24px;\n}\n", ""]);

// exports
